<template>
  <div class="header">
    <nav class="nav">
      <ul class="nav-ul-wrap">
        <li class="on home">
          <span class="icon iconfont">&#xe642;</span>
          All Categories
          <div class="cart-box all-categories">
            <el-cascader-panel :options="allCategoriesList" :props="{ expandTrigger: 'hover',checkStrictly: true }" @change="categoriesChange"></el-cascader-panel>
          </div>
        </li>
        <li v-for="(item,index) in categoryList.slice(0, 6)" :key="index" @click="jumpCategory(item)">
          {{item.classifyName}}
        </li>
      </ul>
    </nav>
    <div class="search" style="width:294px">
      <div class="searchSelect">
        <el-dropdown @command="searchCommand" trigger="click">
              <span class="el-dropdown-link">{{searchVal}}
                <i class="el-icon-arrow-down cur-poi el-icon--right"></i>
              </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="goods">Goods</el-dropdown-item>
            <el-dropdown-item command="Shops">Shops</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="searchRight">
        <input type="text"
          v-model="keyword"
          @keyup.enter="searchPro"
          placeholder="please input goods info."
        >
      </div>
      <span class="btn cur-poi" @click="searchPro">
        <i class="icon el-icon-search"></i>
      </span>
    </div>
  </div>
</template>

<script>
import {
  getCategory
} from '@/api/nav.js'
import { mapMutations } from 'vuex'
export default {
  name: 'homHeader',
  data () {
    return {
      searchVal: 'Goods',
      keyword: '',
      isCategoriesShow: false,
      categoryList: [],
      allCategoriesList: []
    }
  },
  mounted () {
    this.getCategoryData()
  },
  methods: {
    ...mapMutations({
      setSearchObj: 'SET_SEARCHOBJ'
    }),
    searchCommand (command) {
      this.searchVal = command
    },
    // 查找
    searchPro () {
      this.setSearchObj({
        keyword: this.keyword,
        searchVal: this.searchVal
      })
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
    categoriesShow () {
      this.isCategoriesShow = true
    },
    async getCategoryData () {
      const response = await getCategory()
      const res = response.data
      if (res.code === '200') {
        this.categoryList = res.data
        res.data.forEach(c1 => {
          let cateItem = {
            value: c1.classifyId,
            label: c1.classifyName,
            children: []
          }
          c1.childs.forEach(c2 => {
            let cateItem2 = {
              value: c2.classifyId,
              label: c2.classifyName,
              children: []
            }
            c2.childs.forEach(c3 => {
              let cateItem3 = {
                value: c3.classifyId,
                label: c3.classifyName
              }
              cateItem2.children.push(cateItem3)
            })
            if (cateItem2.children.length <= 0) {
              delete cateItem2.children
            }
            cateItem.children.push(cateItem2)
          })
          if (cateItem.children.length <= 0) {
            delete cateItem.children
          }
          this.allCategoriesList.push(cateItem)
        })
      }
    },
    categoriesChange (value) {
      if (!value || value.length<=0) {
        return
      }
      let selectedClassifyId = value[value.length-1]
      this.categoryList.forEach(c1 => {
        if (c1.classifyId === selectedClassifyId) {
          this.jumpCategory(c1)
          return
        }
        c1.childs.forEach(c2 => {
          if (c2.classifyId === selectedClassifyId) {
            this.jumpCategory(c2)
            return
          }
          c2.childs.forEach(c3 => {
            if (c3.classifyId === selectedClassifyId) {
              this.jumpCategory(c3)
              return
            }
          })
        })
      })
    },
    // 跳转到类别主页
    jumpCategory (item) {
      this.$router.push({
        name: 'category',
        query: {
          classifyData: JSON.stringify(item)
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
$lightBlack: #666666;
$navSearchHeight: 39px;
.header{
  height: 80px;
  line-height: 80px;
  width: 1250px;
  margin: 0 auto;
  padding: 0 10px;
  box-sizing: border-box;
  .nav{
    height: 100%;
    float: left;
    .home{
      &:hover{
        .all-categories{
          display: block;
        }
      }
    }
    .nav-ul-wrap {
      height: 100%;
    }
    li{
      display: inline-block;
      font-size: 14px;
      height: 100%;
      color: #3c3c3c;
      cursor: pointer;
      border-bottom: 3px solid #fff;
      margin-left: 25px;
      transition: color .3s ease;
      position: relative;
      &:first-child{
        margin-left: 0;
      }
      &.on,&:hover{
        color: #C5AA7B;
        // border-color: #C5AA7B;
      }
      .cart-box{
        position: absolute;
        top: 100px;
        // top: 100%;
        background-color: #fff;
        color: #3d3d3d;
        z-index: 999;
        // border-radius: 5px;
        box-shadow: 0px 0px 24px 3px rgba(0, 0, 0, 0.06);
        .cartImgBox {
          img {
            width: 100%;
          }
        }
        &.all-categories{
          left: 0px;
          top: 60px;
          display: none;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          >>>.el-cascader-menu__wrap {
            height: 500px;
            .el-cascader-menu__list {
              font-size: 13px;
            }
          }
          .btn{
            display: inline-block;
            padding: 0 15px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            color: #fff;
            background-color: $mainColor;
            border-radius: 4px;
            margin-bottom: 40px;
          }
          .p{
            color: #666666;
            line-height: 1em;
          }
        }
      }
    }
  }
  .search{
    width: 394px;
    height: 40px;
    border: 2px solid #e3d5bd;
    border-radius: 20px;
    float: right;
    margin-top: 21px;
    display: flex;
    .searchSelect{
      width: 72px;
      height: 30px;
      margin-top: 3px;
      padding: 0 10px;
      border-right: 1px solid #dedede;
      text-align: center;
      line-height: 30px;
      white-space: nowrap;
      cursor: pointer;
      .el-dropdown{
        color: #C5AA7B;
        >>>.el-dropdown-link {
          font-size: 12px;
        }
      }
    }
    .searchRight{
      flex: 1;
      line-height: 35px;
      input{
        padding-left: 15px;
        font-size: 12px;
        color: #3c3c3c;
        line-height: 35px;
      }
    }
    .btn{
      font-size: 20px;
      line-height: 38px;
      padding-right: 15px;
      color: #696969;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/homHeader.vue